import { type ReactNode } from 'react';
import { X } from 'lucide-react';
import { cn } from '@/utils/cn';

const BACKDROP =
  'absolute inset-0 transition-opacity ease-out bg-void/60 backdrop-blur-md';

export function ModalHeader({
  title,
  onClose,
}: {
  title: string;
  onClose?: () => void;
}): ReactNode {
  if (!title && !onClose) return null;
  return (
    <div className="mb-base flex items-center justify-between">
      <h2 className="font-display text-sm font-medium text-text-primary">
        {title}
      </h2>
      {onClose && (
        <button
          onClick={onClose}
          className="text-text-tertiary hover:text-text-primary"
          aria-label="Close"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}

export function Backdrop({
  visible,
  dur,
  onClose,
}: {
  visible: boolean;
  dur: React.CSSProperties;
  onClose: () => void;
}): ReactNode {
  return (
    <div
      className={cn(BACKDROP, visible ? 'opacity-100' : 'opacity-0')}
      style={dur}
      onClick={onClose}
      role="presentation"
    />
  );
}
